import type { Category } from '@/types';

/**
 * Represents the structure of a category received from the backend API.
 */
export interface CategoryDTO {
  id: number; // Category ID
  name: string; // Legacy name of the category
  language: string; // Legacy language of the category
  languages: string[]; // List of category languages
  localizations: Record<string, { name: string }>; // Localizations by language
  extlink: string; // External link associated with the category
  short_url: string; // short_url URL for the category
  hide_from_list: boolean; // Indicates if the category should be hidden from the dropdown list / global filter
  num_events: number; // Number of events associated with the category (warning: includes past events)
  category_sort_event: Array<{
    category_id: number;
    event_id: number;
    sort_order: number;
  }>; // Event sorting details
  promoted: boolean; // Indicates if the category is promoted
  info1: string; // Name of the category (for promoted categories)
  photo: string; // Photo ID associated with the category
}

/**
 * Transforms a CategoryDTO object into a Category object used in the frontend.
 * @param dto - The CategoryDTO object received from the backend.
 * @returns The transformed Category object.
 */
export function mapDtoToCategory(dto: CategoryDTO): Category {
return {
        ...dto,
        hide_from_list: Boolean(dto.hide_from_list), // Cast int to boolean
        promoted: Boolean(dto.promoted), // Cast string to boolean
};
}

/**
 * Transforms an array of CategoryDTO objects into an array of Category objects.
 * @param dtos - The array of CategoryDTO objects received from the backend.
 * @returns The transformed array of Category objects.
 */
export function mapDtosToCategories(dtos: CategoryDTO[]): Category[] {
  return dtos.map(mapDtoToCategory);
}